import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import MusicPreviews from './components/MusicPreviews';
import AlbumGrid from './components/AlbumGrid';
import ComingSoon from './components/ComingSoon';
import EmailSignup from './components/EmailSignup';
import RippleEffect from './components/RippleEffect';
import PricesPage from './components/PricesPage';
import RhyLogo from './components/RhyLogo';
import Games from './components/Games';
import Globe from './components/Globe';
import { RippleProvider } from './context/RippleContext';

const HomePage = () => {
  return (
    <div className="App" data-testid="app-container">
      {/* RHY Logo Sticker with Fun Facts */}
      <RhyLogo />
      
      {/* Water Ripple Effect on Tap */}
      <RippleEffect />
      
      {/* Film Grain Overlay */}
      <div className="grain-overlay" aria-hidden="true" />
      
      {/* Hero Section */}
      <Hero />
      
      {/* Music Previews - TikTok Style */}
      <MusicPreviews />
      
      {/* Albums Section */}
      <AlbumGrid />
      
      {/* Coming Soon Section */}
      <ComingSoon />
      
      {/* 3D Globe - Vote for RHY to come to your city */}
      <Globe />
      
      {/* Email Signup & Donations */}
      <EmailSignup />
      
      {/* Games Section */}
      <Games />
      
      {/* Footer */}
      <footer className="footer" data-testid="footer">
        <p className="footer-text">
          © {new Date().getFullYear()} RHY — All Rights Reserved
        </p>
      </footer>
    </div>
  );
};

function App() {
  return (
    <RippleProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/prices/:serviceId" element={<PricesPage />} />
        </Routes>
      </BrowserRouter>
    </RippleProvider>
  );
}

export default App;
